
import Vue from 'vue';
import IRow from '@/pages/search/results/table/IRow.vue';
import HitContext from '@/pages/search/results/table/HitContext.vue';

import GlossField from '@/pages/search/form/concept/GlossField.vue';
import { HitRowData } from '@/pages/search/results/table/table-layout';
import { corpusCustomizations } from '@/utils/customization';

export default Vue.component('HitRow', IRow.extend({
	props: { row: Object as () => HitRowData },
	components: {
		GlossField,
		HitContext
	},
	methods: {
		hover(v: any) { this.$emit('hover', v); },
		unhover(v: any) { this.$emit('unhover', v); },
	},
	computed: {
		showCustomHitInfoLink(): boolean {
			return !!this.row.href && corpusCustomizations.results.customHitInfoLink;
		}
	}
}));
